import React, { useState } from 'react';

import { AnimatePresence } from 'framer-motion';

import { type ExpireOption } from '@pkg/hooks';

import { useBuyStore, useListStore, useTempSheetStore } from '@app/store/zustand';

import { AssetBuyModal } from '../AssetBuyModal';
import { AssetListingModal } from '../AssetListingModal';
import { AssetListingSheet } from '../AssetListingSheet';
import { AssetOfferSheet } from '../AssetOfferSheet';

export function MarketplaceOverlays() {
    const {
        token: buyToken,
        confirmedToken: buyTokenConfirmed,
        removeToken: removeBuyToken,
        removeConfirmedToken: removeConfirmedBuyToken,
    } = useBuyStore();

    const {
        token: listToken,
        confirmedToken: listTokenConfirmed,
        pendingConfirmation: pendingListingConfirmation,
        setPendingConfirmation,
        removeToken: removeListToken,
        removeConfirmedToken: removeConfirmedListToken,
    } = useListStore();
    const { showOfferSheet, setShowOfferSheet } = useTempSheetStore();

    // TODO: This is temporary state until we have completed the integration.
    const [expiration, setExpiration] = useState<ExpireOption>('week');

    const listingSheetMarkup = listToken ? (
        <AssetListingSheet expiration={expiration} onExpirationChange={setExpiration} onClose={removeListToken} />
    ) : null;

    const offerSheetMarkup = showOfferSheet ? (
        <AssetOfferSheet
            expiration={expiration}
            onClose={() => setShowOfferSheet(false)}
            onExpirationChange={setExpiration}
        />
    ) : null;

    const listingModalConfirmation =
        pendingListingConfirmation && listToken ? (
            <AssetListingModal
                key="AssetListingModalConfirmation"
                asset={listToken}
                onClose={() => setPendingConfirmation(false)}
            />
        ) : null;

    const listingModalConfirmed = listTokenConfirmed ? (
        <AssetListingModal
            key="AssetListingModalConfirmed"
            type="postListing"
            asset={listTokenConfirmed}
            onClose={removeConfirmedListToken}
        />
    ) : null;

    const buyModalConfirmation = buyToken ? (
        <AssetBuyModal key="AssetBuyModalConfirmation" asset={buyToken} onClose={removeBuyToken} />
    ) : null;

    const buyModalConfirmed = buyTokenConfirmed ? (
        <AssetBuyModal
            key="AssetBuyModalConfirmed"
            type="postBuy"
            asset={buyTokenConfirmed}
            onClose={removeConfirmedBuyToken}
        />
    ) : null;

    return (
        <AnimatePresence>
            {listingSheetMarkup}
            {listingModalConfirmation}
            {listingModalConfirmed}

            {offerSheetMarkup}

            {buyModalConfirmation}
            {buyModalConfirmed}
        </AnimatePresence>
    );
}
